import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { Dispatch, bindActionCreators } from "redux";
import { styles } from "./style";
import { connect } from "react-redux";
import { Dialog } from "component/shared/dialog";
import { AppDatePicker, AppTimePicker } from "component/shared/date-picker";
import * as Icons from "react-feather";
import moment, { Moment } from "moment";
import * as yup from "yup";
import { validate } from "shared/yup";
import * as env from "shared/env";

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface OwnProps {
	open: boolean;
	onClose: Function;
	onSend: (sendOn: moment.Moment) => void;
}

interface Props extends
	OwnProps,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles>
{}

interface State {
	sendDate: Moment;
	sendTime: Moment;
}

const initialState: State = {
	sendDate: moment(),
	sendTime: moment(),
}

class Component extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);
		this.state = initialState;
	}

	public componentDidUpdate(prevProps: Props) {
		if (!prevProps.open && this.props.open) {
			this.setState(initialState);
		}
	}

	private combineDateAndTime = (date: Moment, time: Moment) => {
		return date.set({
			hour: time.get("hour"),
			minute: time.get("minute"),
			second: 0,
			millisecond: 0,
		})
	};

	private get sendOn() {
		const { sendDate, sendTime } = this.state;
		return this.combineDateAndTime(sendDate, sendTime);
	}

	private onChangeSendDate = (date: Date | null) => {
		const sendDate = moment(date!);
		this.setState({ sendDate });
	}

	private onChangeSendTime = (date: Date | null) => {
		const sendTime = moment(date!);
		this.setState({ sendTime });
	}

	private validationSchema = {
		sendDate: yup
			.mixed()
			.required("Start date is required."),
		sendTime: yup
			.mixed()
			.required("Start time is required."),
	};

	public render() {
		const { classes = {}, open, onClose } = this.props;
		const {
			sendDate,
			sendTime,
		} = this.state;
		const { sendOn } = this;
		const errors = validate(this.validationSchema, { ...this.state, sendOn });
		return (
			<Dialog open={open} onClose={() => onClose(sendOn)} scroll="paper">
				<Mui.DialogTitle>
					Send Later
				</Mui.DialogTitle>
				<Mui.DialogContent
					style={{
						padding: "8px 50px",
					}}
				>
					<Mui.Grid container alignItems="flex-start" spacing={1}>
						<Mui.Grid item xs={6}>

								<AppDatePicker
									required
									maxDate={new Date(2100, 0, 1)}
									error={errors && !!errors.sendDate}
									helperText={errors && errors.sendDate}
									helperTextClassName={classes.errorMessage}
									inputClassName={classes.adornedEnd}
									inputLabelClasses={{ asterisk: classes.labelAsterisk }}
									format="MM/dd/yyyy"
									fullWidth
									margin="dense"
									label="Send Date "
									placeholder="mm/dd/yyyy"
									onChange={date => this.onChangeSendDate(date)}
									value={sendDate ? sendDate.toDate() : null}
									openPickerIcon={<Icons.Calendar />}
									views={["day"]}
								/>

						</Mui.Grid>
						<Mui.Grid item xs={6}>

								<AppTimePicker
									required
									error={errors && !!errors.sendTime}
									helperText={errors && errors.sendTime}
									helperTextClassName={classes.errorMessage}
									inputClassName={classes.adornedEnd}
									inputLabelClasses={{ asterisk: classes.labelAsterisk }}
									format="hh:mm aa"
									ampm={true}
									fullWidth
									margin="dense"
									label="Send Time "
									placeholder="00:00 AM"
									onChange={time => this.onChangeSendTime(time)}
									value={sendTime ? sendTime.toDate() : null}
									openPickerIcon={<Icons.Clock />}
									views={["hours", "minutes"]}
								/>

						</Mui.Grid>
					</Mui.Grid>
					<Mui.Grid container alignItems="flex-start" spacing={1}>
						<Mui.Grid container item style={{ marginTop: 16, marginBottom: 12 }}>
							<Mui.Grid container item xs={12}>
								<div style={{ flex: 1 }} />
								<Mui.Button
									className={classes.button}
									style={{ marginRight: 8 }}
									variant="contained"
									color={"primary"}
									onClick={() => onClose(this.props.onSend(sendOn))}
									disabled={!!errors}
								>
									Send
								</Mui.Button>
								<Mui.Button
									className={classes.button}
									variant="outlined"
									color="primary"
									onClick={() => onClose(sendOn)}
								>
									Cancel
								</Mui.Button>
							</Mui.Grid>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.DialogContent>
			</Dialog>
		)
	}
}
export const EditSendDialog = withStyles(connect(
	mapDispatchToProps,
)(Component), styles);
